import React from 'react'
import Translator from '../Translator.js'

import { useModalContext } from '../context/ModalContext.js'


function Main() {
  const {showModal, setShowModal, data, setData} = useModalContext()
  let l = Translator()
  
  const Urunler = [
    {
      ad: l.Course.anaYemekIsim1,
      icerik: l.Course.anaYemekIcerik1,
      img: "./images/anayemek/margarita.webp",
      fiyat: '120',
      tur: 'Pizza',
    },
    {
      ad: l.Course.anaYemekIsim2,
      icerik: l.Course.anaYemekIcerik2,
      img: "./images/anayemek/karisik.jpg",
      fiyat: '155',
    },
    {
      ad: l.Course.anaYemekIsim3,
      icerik: l.Course.anaYemekIcerik3,
      img: "./images/anayemek/tonbalik.jpg",
      fiyat: '175',
    },
    {
      ad: l.Course.anaYemekIsim4,
      icerik: l.Course.anaYemekIcerik4,
      img: "./images/anayemek/bbqpizza.jpg",
      fiyat: '185',
    },
    {
      ad: l.Course.anaYemekIsim5,
      icerik: l.Course.anaYemekIcerik5,
      img: "./images/anayemek/bolonez.jpg",
      fiyat: '195',
    },
    {
      ad: l.Course.anaYemekIsim6,
      icerik: l.Course.anaYemekIcerik6,
      img: "./images/anayemek/karisiktost.jpg",
      fiyat: '75',
      tur: "Tost",
    },
    {
      ad: l.Course.anaYemekIsim7,
      icerik: l.Course.anaYemekIcerik7,
      img: "./images/anayemek/kasarlitost.webp",
      fiyat: '60',
    },
    {
      ad: l.Course.anaYemekIsim8,
      icerik: l.Course.anaYemekIcerik8,
      img: "./images/anayemek/ciftkasarli.jpg",
      fiyat: '65',
    },
    {
      ad: l.Course.anaYemekIsim9,
      icerik: l.Course.anaYemekIcerik9,
      img: "./images/anayemek/etlitaco.jpg",
      fiyat: '195', 
      tur: "Taco",
    },
    {
      ad: l.Course.anaYemekIsim10,
      icerik: l.Course.anaYemekIcerik10,
      img: "./images/anayemek/tavuklutaco.jpg",
      fiyat: '170', 
    },
    {
      ad: l.Course.anaYemekIsim11,
      icerik: l.Course.anaYemekIcerik11,
      img: "./images/anayemek/karideslitaco.jpg",
      fiyat: '190', 
    },
    {
      ad: l.Course.anaYemekIsim12,
      icerik: l.Course.anaYemekIcerik12,
      img: "./images/anayemek/tavuksis.webp",
      fiyat: '150', 
      tur: "Izgara",
    },
    {
      ad: l.Course.anaYemekIsim13,
      icerik: l.Course.anaYemekIcerik13,
      img: "./images/anayemek/antrikot.jpg",
      fiyat: '280', 
    },
    {
      ad: l.Course.anaYemekIsim14,
      icerik: l.Course.anaYemekIcerik14,
      img: "./images/anayemek/kofteporsiyon.jpg",
      fiyat: '160', 
    },
    {
      ad: l.Course.anaYemekIsim15,
      icerik: l.Course.anaYemekIcerik15,
      img: "./images/anayemek/ekmekarasikofte.webp",
      fiyat: '90', 
    },

    {
      ad: l.Course.anaYemekIsim17,
      icerik: l.Course.anaYemekIcerik17,
      img: "./images/anayemek/hamburger.jpg",
      fiyat: '150', 
      tur: "Burger"
    },
    {
      ad: l.Course.anaYemekIsim18,
      icerik: l.Course.anaYemekIcerik18,
      img: "./images/anayemek/cheeseburger.jpg",
      fiyat: '155',  
    },
    {
      ad: l.Course.anaYemekIsim19,
      icerik: l.Course.anaYemekIcerik19,
      img: "./images/anayemek/tavukburger.jpg",
      fiyat: '130',  
    },
    {
      ad: l.Course.anaYemekIsim20,
      icerik: l.Course.anaYemekIcerik20,
      img: "./images/anayemek/hamburgermenu.jpg",
      fiyat: '185',  
    },
    {
      ad: l.Course.anaYemekIsim21,
      icerik: l.Course.anaYemekIcerik21,
      img: "./images/anayemek/cheeseburgermenu.jpg",
      fiyat: '190',  
    },
    {
      ad: l.Course.anaYemekIsim22,
      icerik: l.Course.anaYemekIcerik22,
      img: "./images/anayemek/tavukburgermenu.jpg",
      fiyat: '170',  
    }, 
    {
      ad: l.Course.anaYemekIsim23,
      icerik: l.Course.anaYemekIcerik23,
      img: "./images/anayemek/mantarsoslutavuk.webp",
      fiyat: '165',  
      tur: "Tavuk"
    },
    {
      ad: l.Course.anaYemekIsim24,
      icerik: l.Course.anaYemekIcerik24,
      img: "./images/anayemek/korisoslutavuk.webp",
      fiyat: '175',  
    },
    {
      ad: l.Course.anaYemekIsim25,
      icerik: l.Course.anaYemekIcerik25,
      img: "./images/anayemek/sintavuk.webp",
      fiyat: '170',  
    },
    {
      ad: l.Course.anaYemekIsim26,
      icerik: l.Course.anaYemekIcerik26,
      img: "./images/anayemek/bolonezspagetti.jpg",
      fiyat: '155',  
      tur: "Makarna",
    },
    {
      ad: l.Course.anaYemekIsim27,
      icerik: l.Course.anaYemekIcerik27,
      img: "./images/anayemek/pennearabiata.jpg",
      fiyat: '105',   
    },
    {
      ad: l.Course.anaYemekIsim28,
      icerik: l.Course.anaYemekIcerik28,
      img: "./images/anayemek/korilipenne.jpg",
      fiyat: '135',   
    },
    {
      ad: l.Course.anaYemekIsim29,
      icerik: l.Course.anaYemekIcerik29,
      img: "./images/anayemek/pestososlumakarna.jpg",
      fiyat: '105',   
    },
    {
      ad: l.Course.anaYemekIsim30,
      icerik: l.Course.anaYemekIcerik30,
      img: "./images/anayemek/karideslilinguni.jpg",
      fiyat: '185',   
    },
    {
      ad: l.Course.anaYemekIsim33,
      icerik: l.Course.anaYemekIcerik33,
      img: "./images/anayemek/fettucinimakarna.webp",
      fiyat: '155',   
    }, 
    {
      ad: l.Course.anaYemekIsim31,
      icerik: l.Course.anaYemekIcerik31,
      img: "./images/anayemek/manti.jpg",
      fiyat: '130',   
    },
    {
      ad: l.Course.anaYemekIsim32,
      icerik: l.Course.anaYemekIcerik32,
      img: "./images/anayemek/cevizlimanti.jpg",
      fiyat: '140',   
    },
    {
      ad: l.Course.anaYemekIsim34,
      icerik: l.Course.anaYemekIcerik34,
      img: "./images/anayemek/tavukwrap.jpg",
      fiyat: '140',   
      tur: 'Dürümler'
    },
    {
      ad: l.Course.anaYemekIsim35,
      icerik: l.Course.anaYemekIcerik35,
      img: "./images/anayemek/etliwrap.jpg",
      fiyat: '175',    
    },
    {
      ad: l.Course.anaYemekIsim36,
      icerik: l.Course.anaYemekIcerik36,
      img: "./images/anayemek/barbun.webp",
      fiyat: '200',   
      tur: 'Balik'
    },
    {
      ad: l.Course.anaYemekIsim37,
      icerik: l.Course.anaYemekIcerik37,
      img: "./images/anayemek/cupra.jpg",
      fiyat: '200',    
    },
  ]

  const nameRenderer = (name) => {
    switch (name) {
      case "Pizza": return l.Course.mnBaslik1;
      case "Tost": return  l.Course.mnBaslik2;
      case "Taco": return l.Course.mnBaslik3;
      case "Izgara": return l.Course.mnBaslik4;
      case "Burger": return l.Course.mnBaslik5;
      case "Tavuk": return l.Course.mnBaslik6;
      case "Makarna": return l.Course.mnBaslik7;
      case "Dürümler": return l.Course.mnBaslik8;
      case "Balik": return l.Course.mnBaslik9;
    }
  }

  return (
    <div>
      <div className="flex flex-col w-full p-5 border-b-4 border-gray-700">
        <h1 className="text-4xl font-bold text-red-600 text-center">{l.Main.btn2}</h1>
        {Urunler.map((item, i) => [
          <div> 
         <h1 className="text-7xl font-bold text-[#da963e] text-center">{nameRenderer(item.tur)}</h1>  
          <div key={i}>
            <div className="flex flex-col items-left justify-between py-2 border-4 mt-2 shadow-xl rounded-sm border-gray-700">
              <div className="cursor-pointer text-xl px-5 font-semibold" onClick={() => {setData(item.img); setShowModal(true)}}>{item.ad} <i className="fa-regular fa-image"></i></div>
              <div className="text-md px-5 font-thin">{item.icerik}</div>
              <div className="text-md px-5 font-black text-blue-600">{item.fiyat}₺</div>
            </div>
          </div>
          </div>
        ])}
      </div>
    </div>
  )
}

export default Main
